export enum PaymentMethod {
  NONE = 'none',
  SEPA = 'sepa',
  MOLLIE = 'mollie',
}

export enum Role {
  Administrator = 'administrator',
  Planner = 'planner',
  Driver = 'driver',
  CoDriver = 'co_driver',
  Inactive = 'inactive',
}
